import {
  getCalculator,
  setCalculator
} from 'components/StudentTools/StudentTools'
import { useDraggable } from 'hooks/useDraggable'
import {
  destroyTiCalculator,
  TiCalculatorInstance
} from 'util/showTiCalculator'
import AssessmentContainerLayout from './Assessments/AssessmentContainer'
import AssignmentContainer from './Assignments/AssignmentContainer'
import { useParams } from 'react-router-dom'
import Close from 'assets/img/remove-icon-bold.svg'
import {
  CalculatorCloseButton,
  CalculatorHost,
  CalculatorOverlay,
  CalculatorPanel,
  ContrastContentArea
} from './styles'

const Assessment = () => {
  const { assessmentType } = useParams()
  const isBenchmark = assessmentType === 'benchmarks'
  const isFormative = assessmentType === 'formatives'
  const isAssignment = assessmentType === 'assignments'
  const { dragRef, position, handlers } = useDraggable({
    defaultPosition: { x: 0, y: 0 },
    cancel: '.closeTooltipBtn'
  })

  function closeCalculatorOverlay() {
    const calculator = getCalculator()
    const calculatorElement = document.getElementById('desmos-calculator')

    /**
     * The overlay close button can be shutting down either runtime, so the
     * shared close flow needs TI-specific teardown before the host is hidden.
     */
    if ((calculator as TiCalculatorInstance | null)?.killInstance) {
      destroyTiCalculator(
        calculator as TiCalculatorInstance | null,
        calculatorElement as HTMLDivElement | null
      )
      if (calculatorElement) {
        calculatorElement.innerHTML = ''
      }
    } else {
      calculator && calculator.destroy()
    }

    setCalculator(null)

    if (calculatorElement) {
      const overlayElement = calculatorElement.closest(
        '[data-calculator-overlay="true"]'
      ) as HTMLElement | null

      if (overlayElement) {
        overlayElement.style.display = 'none'
      }

      calculatorElement.style.display = 'none'
      calculatorElement.style.width = ''
      calculatorElement.style.height = ''
      calculatorElement.style.maxHeight = ''
    }

    window.dispatchEvent(new Event('cms-calculator-close'))
  }

  return (
    <>
      <ContrastContentArea />
      {(isBenchmark || isFormative) && <AssessmentContainerLayout />}
      {isAssignment && <AssignmentContainer />}

      <CalculatorOverlay
        ref={dragRef}
        {...handlers}
        data-calculator-overlay='true'
        style={{
          transform: `translate(${position.x}px, ${position.y}px)`
        }}
      >
        <CalculatorPanel className='cal-main-container'>
          <CalculatorCloseButton
            type='button'
            className='closeTooltipBtn'
            onClick={closeCalculatorOverlay}
            aria-label='Close calculator'
          >
            <img src={Close} alt='Close' />
          </CalculatorCloseButton>

          <CalculatorHost id='desmos-calculator' />
        </CalculatorPanel>
      </CalculatorOverlay>
    </>
  )
}

export default Assessment
